export const RAPTOR_DEBOUNCE_TIME = 300;
export const RAPTOR_STEP_ENTER_TIME = 400;
export const RAPTOR_MULTI_CHOICE_NONE_VALUE = 'NONE_VALUE';
export const RAPTOR_IS_NONE_DATA_KEY = 'is_none';

export const RAPTOR_EMAIL_ADDRESS = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const RAPTOR_MOBILE_NUMBER_AU = /^(\+?61\s?|0)4([-\s]?\d){8}$/;
export const RAPTOR_TELEPHONE_NUMBER_AU = /^((\+?61\s?|0)\d)?([-\s]?\d){8}$/;
export const RAPTOR_MOBILE_NUMBER_NZ = /^(\+?64\s?|0)2([-\s]?\d){7,9}$/;
export const RAPTOR_TELEPHONE_NUMBER_NZ = /^((\+?64\s?|0)\d)?([-\s]?\d){7,9}$/;
export const RAPTOR_MOBILE_NUMBER_UK = /^(?:\+?44\s*)?(?:0)?7(?:[\s-]*\d){9}$/;
export const RAPTOR_TELEPHONE_NUMBER_INTERNATIONAL = /^((\+?\d{1,3}\s?|0)\d)?([-\s]?\d){4,10}$/;
export const RAPTOR_AHM_MEDIBANK_MEMBER_NUMBER = /^[0-9]{8}[A-Za-z]?$/;

export const RAPTOR_PREDICATE_VARIABLES = [
  'const_current_date',
  'const_policy_start_date',
  'const_is_staff'
];
export const RAPTOR_PREDICATE_CURRENT_DATE = 'const_current_date';
export const RAPTOR_MEDICAL_VALUE_KEY = '_medical_conditions';

export const RAPTOR_COLUMN_LAYOUT_CLASSES = {
  base: 'cell cell-small-col-span-6',
  columns: [
    [
      'cell-medium-col-span-8 cell-large-col-span-12'
    ],
    [
      'cell-small-col-span-6 cell-medium-col-span-4 cell-large-col-span-6',
      'cell-small-col-span-6 cell-medium-col-span-8 cell-large-col-span-12'
    ],
    [
      'cell-small-col-span-6 cell-medium-col-span-8 cell-large-col-span-4',
      'cell-small-col-span-6 cell-medium-col-span-8 cell-large-col-span-8',
      'cell-small-col-span-6 cell-medium-col-span-8 cell-large-col-span-12'
    ]
  ]
};

export const RAPTOR_COUNTRY_CODES = {
  AUS: {
    icon: `🇦🇺`,
    code: '61',
    validation: RAPTOR_MOBILE_NUMBER_AU
  },
  GBR: {
    icon: `🇬🇧`,
    code: '44',
    validation: RAPTOR_MOBILE_NUMBER_UK
  },
  NZL: {
    icon: `🇳🇿`,
    code: '64',
    validation: RAPTOR_MOBILE_NUMBER_NZ
  }
};
export const RAPTOR_ARRANGEMENT_TAG: { [x: string]: string; } = {
  GB: 'All figures include 20% Insurance Premium Tax',
  AU: 'Including GST and Gov&apos;t charges (as&nbsp;applicable)',
}
